import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhatIsSection from './components/WhatIsSection';
import WhyUseSection from './components/WhyUseSection';
import CategoryGrid from './components/CategoryGrid';
import SafetySection from './components/SafetySection';
import HowItWorks from './components/HowItWorks';
import ArticlePreview from './components/ArticlePreview';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <WhatIsSection />
        <WhyUseSection />
        <CategoryGrid />
        <SafetySection />
        <HowItWorks />
        <ArticlePreview />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}